import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { KustoLinkedService } from 'app/model/linkedservice/kusto.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(KustoLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                endpoint: '*',
                servicePrincipalId: '*',
                servicePrincipalKey: 'secret',
                encryptedCredential: '*'
            }
        }
    }
})
export class KustoLinkedServiceAdapter extends LinkedServiceAdapter<KustoLinkedService> {
    protected modelConstructor(): new () => KustoLinkedService {
        return KustoLinkedService;
    }

    protected model(): IModel {
        return KustoLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: KustoLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.KustoLinkedService;
        properties.type = Metamodel.modelFor(KustoLinkedService).name;
        const servicePrincipalKey = passwordOrAKVtoSecretBase(linkedService.servicePrincipalKey, this.context);
        properties.typeProperties = {
            endpoint: linkedService.endpoint,
            servicePrincipalId: linkedService.servicePrincipalId,
            servicePrincipalKey
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: KustoLinkedService): Promise<KustoLinkedService> {
        const properties = linkedServiceResource.properties as Model.KustoLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.KustoLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.endpoint = typeProperties.endpoint;
        linkedService.servicePrincipalId = typeProperties.servicePrincipalId;
        linkedService.servicePrincipalKey = secretBaseToPasswordOrAKV(typeProperties.servicePrincipalKey, true, this.context);

        return linkedService;
    }
}
